// ======================================================================
// File Name       : messageThread
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const RECEIVE_MESSAGE_LIST = 'RECEIVE_MESSAGE_LIST';
export const ADD_USER_TO_LIST = 'ADD_USER_TO_LIST';
export const REMOVE_USER_FROM_LIST = 'REMOVE_USER_FROM_LIST';
export const STORE_INIT_DATA = 'STORE_INIT_DATA';
export const STORE_USER_SEARCH_RESULT = 'STORE_USER_SEARCH_RESULT';
export const RESET_EDITTING_USERS = 'RESET_EDITTING_USERS';
export const RECEIVE_MESSAGE_THREAD_INFO = 'RECEIVE_MESSAGE_THREAD_INFO';
export const RECEIVE_MESSAGE_THREAD_USER_PAGING = 'RECEIVE_MESSAGE_THREAD_USER_PAGING';
export const RECEIVE_INIT_MESSAGE_STRUCTURE = 'RECEIVE_INIT_MESSAGE_STRUCTURE';
export const RECEIVE_MESSAGE_STRUCTURE = 'RECEIVE_MESSAGE_STRUCTURE';
export const LOAD_MORE_MESSAGE = 'LOAD_MORE_MESSAGE';
export const RELOAD_CHAT_AFTER_DELETE = 'RELOAD_CHAT_AFTER_DELETE';
export const RESET_IS_LOAD_MORE = 'RESET_IS_LOAD_MORE';
export const REMOVED_USER_IN_DIALOG = 'REMOVED_USER_IN_DIALOG';
export const REMOVE_ALL_USER_FROM_LIST = 'REMOVE_ALL_USER_FROM_LIST';
export const MESSAGE_THREAD_RESET_DATA = 'MESSAGE_THREAD_RESET_DATA'; // Step 10.0.0
